import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import SiteConfig from 'site-config';

export default {
    name: "ListPanelMixin",
    inject: {
        userForm: {
            from: "userForm",
            default: null
        }
    },
    data: function() {
        return {
            IsSysAdmin: false,
            CurUserForm: null
        };
    },
    computed: {
        Locale: function() {
            return zhCN;
        },
        PreUserFormList: function() {
            return this.$store.state.PreUserFormList;
        },
        ListPanelTitle: function() {
            return `${this.CurUserForm.UserFormDesc} [共${this.CurUserForm.DataPaging.RecCount}条记录]`;
        },
        //搜索字段列表
        SearchColList: function() {

            let _colList = [];
            let _beforeThreeColName = "";
            let _beforeThreeColTitle = "";
            let _hasAddCount = 0; //已经加入默认搜索的字段数量

            this.CurUserForm.ColInfo.forEach((item, index) => {

                if (item.ColControlName !== "MultiSelectRow" && item.IsAllowSearch !== "0") {

                    _colList.push(item);

                    if (_hasAddCount < 3) {
                        _hasAddCount++;
                        _beforeThreeColName += _beforeThreeColName ? `/${item.ColName}` : item.ColName;
                        _beforeThreeColTitle += _beforeThreeColTitle ? `/${item.ColTitle}` : item.ColTitle;
                    }
                }
            });

            return _colList.length == 0 ? [] : [{
                ColName: _beforeThreeColName,
                ColTitle: _beforeThreeColTitle
            }].concat(_colList.length > 1 ? _colList : []);
        },
        //是否显示返回按钮
        IsShowPreUserForm: function() {

            let _viewStateData = this.CurUserForm.GetViewStateData();

            return (_viewStateData?.ReturnUserFormID || _viewStateData?.ReturnUserFormKey) 
                || (!(_viewStateData?.IsShowPreUserForm === "0" || _viewStateData?.IsShowPreUserForm === 0) && this.PreUserFormList.length > 0);
        }
    },
    created: function() {

        this.GetCurUserForm();

        CmnMis.Func.IsSysAdmin().then((data) => {
            this.IsSysAdmin = data;
        });
    },
    methods: {
        //获取当前表单
        GetCurUserForm: function() {
            this.CurUserForm = this.userForm || CmnMis.CurUserForm;
        },
        //表格标题排序事件
        OnTitleSort: function(sorter) {

            let _colName = sorter.columnKey;
            let _order = sorter.order;

            let _colInfo = this.CurUserForm.GetColInfo(_colName);

            if (_colInfo["IsCanSort"] !== "1") { return; }

            if (!_order) {
                this.CurUserForm.SortByColName = "";
                this.CurUserForm.SortByDirection = "";
            }
            else {

                this.CurUserForm.SortByColName = _colName;
                if (_order === "ascend") {
                    this.CurUserForm.SortByDirection = "asc";
                }
                else if (_order === "descend") {
                    this.CurUserForm.SortByDirection = "desc";
                }
            }

            this.CurUserForm.GetRecList();
        },
        //点击排序按钮快速排序
        OnSortClick: function(sorter) {

            let _checkResult = this.CurUserForm.CheckIsInSortable();

            if (_checkResult !== true) {

                if(_checkResult === false) {

                    Cmn.Modal.Confirm("现在未处于排序状态！是否要进入排序状态？", () => {

                        this.CurUserForm.SortByColName = this.CurUserForm.GetSortColName();
                        this.CurUserForm.SortByDirection = this.CurUserForm.GetSortColDirection();

                        this.CurUserForm.GetRecList(this.CurUserForm.DataPaging.CurPage);

                        if(this.$refs.DataTable) {
                            this.$refs.DataTable.ReRender();
                        }
                    });
                }
                else {
                    Cmn.Modal.Alert(_checkResult);
                }

                return;
            }

            if (sorter.Action === "Up" || sorter.Action === "Down") {

                this.CurUserForm.RecMoveUpOrDownSort(sorter.RecData, sorter.Action).then((data) => {

                    if(data.IsSuccess == "0") {
                        Cmn.Modal.Alert(data.ErrMsg);
                    }
                });
            }
            else if (sorter.Action === "Top" || sorter.Action === "Bottom") {

                this.CurUserForm.RecToTopOrBottomSort(sorter.RecData, sorter.Action).then((data) => {

                    if(data.IsSuccess == "0") {
                        Cmn.Modal.Alert(data.ErrMsg);
                    }
                });
            }
        },
        //批量删除
        OnBatchDeleteClick: function () {
            
            let _recList = this.CurUserForm.GetSelectedRecListData();

            if(_recList.length <= 0) {
                Cmn.Modal.Alert("您未选择任何要删除的记录！请选择后再进行删除。");
                return;
            }

            let _recIDList = _recList.map(item=>this.CurUserForm.GetCurRecKeyVal(item));

            Cmn.Modal.Confirm(`是否确定要删除"${this.CurUserForm.GetKeyColTitle()}"为"${_recIDList}"的记录？`, ()=>{

                if (this.CurUserForm.HasRecDellRight(_recIDList) === false) {
                    Cmn.Modal.Alert(`您没有"${_recIDList}"记录的删除权限！`);
                    return;
                }

                if (this.CurUserForm.OnDeleteClick.Trigger([_recIDList]) === false) { return; }

                CmnMis.TableOpt.BatchDeleteRec(this.CurUserForm, _recIDList).then(data=>{

                    if (this.CurUserForm.AfterDelete.Trigger([data.IsSuccess === "1", _recIDList]) !== false) {
                        if (data.IsSuccess === "1") { 
                            Cmn.Modal.Success("删除成功！"); 
                            //清除选中行数据
                            this.CurUserForm.ClearSelectRowRecListData();
                        }
                        else { Cmn.Modal.Error("删除失败！" + data.ErrMsg); }
                    }

                    this.CurUserForm.GetRecList(this.CurUserForm.DataPaging.CurPage);
                    
                }, () => {
                    Cmn.Modal.Error("删除失败！请重新尝试。");
                });
            });
        },
        //增加记录
        OnAddClick: function() {

            if (this.CurUserForm.OnAddClick.Trigger() === false) { return; }

            this.CurUserForm.ShowAddRecPanel();
        },
        //删除记录
        OnDeleteClick: function(row) {

            var _recID = this.CurUserForm.GetCurRecKeyVal(row);

            if (this.CurUserForm.HasRecDellRight(_recID) === false) {
                Cmn.Modal.Alert("您没有该记录的删除权限！");
                return;
            }

            if (this.CurUserForm.OnDeleteClick.Trigger([_recID]) === false) { return; }

            this.CurUserForm.CurRecID = _recID;

            //确认删除
            Cmn.Modal.Confirm(this.CurUserForm.FormatPromptCopy(this.CurUserForm.Cfg.PromptCopy.DeleteRec), () => {

                if (this.CurUserForm.BeforeDelete.Trigger([this.CurUserForm.CurRecID]) === false) { return; }

                this.CurUserForm.DeleteRec(_recID).then((data) => {

                    if (this.CurUserForm.AfterDelete.Trigger([data.IsSuccess === "1", this.CurUserForm.CurRecID]) !== false) {
                        if (data.IsSuccess === "1") { Cmn.Modal.Success("删除成功！"); }
                        else { Cmn.Modal.Error("删除失败！" + data.ErrMsg); }
                    }

                    this.CurUserForm.GetRecList(this.CurUserForm.DataPaging.CurPage);
                }, (data) => {
                    Cmn.Modal.Error("删除失败！可能已经存在关联数据。");
                });
            });
        },
        //更新记录
        OnUpdateClick: function(row) {
            var _recID = this.CurUserForm.GetCurRecKeyVal(row);

            if (this.CurUserForm.HasRecModifyRight(_recID) === false) {
                Cmn.Modal.Alert("您没有该记录的修改权限！");
                return;
            }

            if (this.CurUserForm.OnUpdateClick.Trigger([_recID]) === false) { return; }

            this.CurUserForm.ShowUpdateRecPanel(_recID);
        },
        //查看记录
        OnViewClick: function(row) {

            var _recID = this.CurUserForm.GetCurRecKeyVal(row);

            if (this.CurUserForm.BeforeView.Trigger([_recID]) === false) { return; }

            this.CurUserForm.ShowViewRecPanel(_recID);
        },
        OnRowSelectChange: function(keys) {
            
            let _colInfo = this.CurUserForm.GetMultiSelectRowColInfo();

            this.CurUserForm.RecListData.forEach((recData, index)=>{

                let _recID = this.CurUserForm.GetCurRecKeyVal(recData);

                if(keys.indexOf(index) >= 0) {
                    _colInfo.SelectedRecData[_recID] = recData;
                }
                else {
                    delete _colInfo.SelectedRecData[_recID];
                }
            });
        },
        //当前页改变时
        OnCurPageChange: function(current, size) {

            this.CurUserForm.GetRecList(current, false, true);
        },
        //当PageSize改变时
        OnPageSizeChange(current, size) {

            this.CurUserForm.DataPaging.PageSize = size;
            this.CurUserForm.GetRecList(this.CurUserForm.DataPaging.CurPage, false, true);
        },
        //搜索时
        AddCondition: async function(searchParam) {

            let _searchContent = searchParam.SearchContent;

            //是否是区间查找
            if (searchParam.FindInInterval) {

                _searchContent = searchParam.EndSearchValue;

                let _startSearchValue = CmnMis.Func.ToSqlStr(searchParam.StartSearchValue);

                if (_searchContent !== "" && _startSearchValue !== "") {
                    this.CurUserForm.AddCondition("[" + searchParam.SelectedCol + "] between " +
                        await CmnMis.Func.ProcSqlStr(_startSearchValue) + " and " + await CmnMis.Func.ProcSqlStr(_searchContent), "cmn_SearchCondition");
                }
                else if (_startSearchValue !== "") {
                    this.CurUserForm.AddCondition("[" + searchParam.SelectedCol + "] >= " +
                        await CmnMis.Func.ProcSqlStr(_startSearchValue), "cmn_SearchCondition");
                }
                else if (_searchContent !== "") {
                    this.CurUserForm.AddCondition("[" + searchParam.SelectedCol + "] <= " +
                        await CmnMis.Func.ProcSqlStr(_searchContent), "cmn_SearchCondition");
                }
            }
            else {

                let _colName = searchParam.SelectedCol;
                let _searchWay = searchParam.SearchWay; //确定搜索方式：包含、等于等

                if (_searchContent !== "") {

                    var _searchWaySql = "";

                    //等于或不等于不分割空格
                    if(_searchWay === "Equal") {
                        _searchWaySql += " [ColName] =" + await CmnMis.Func.ProcSqlStr(_searchContent);
                    }
                    else if(_searchWay === "NotEqual") {
                        _searchWaySql += " [ColName] <>" + await CmnMis.Func.ProcSqlStr(_searchContent);
                    }
                    else {

                        var _searchContentList = _searchContent.split(' ');

                        //删除搜索内容中空格
                        for (var _i = 0; _i < _searchContentList.length; _i++) {
                            var _tmpContent = Cgl.Str.Trim(_searchContentList[_i]);

                            if (_tmpContent === "") { _searchContentList.splice(_i, 1); _i--; }
                            else { _searchContentList[_i] = _tmpContent; }
                        }

                        for (_i = 0; _i < _searchContentList.length; _i++) {
                            if (_searchWaySql !== "") { _searchWaySql += " and "; }
    
                            if (_searchWay === "Include") {
                                _searchWaySql += " [ColName] like  " + await CmnMis.Func.ProcSqlStr("%" + _searchContentList[_i] + "%",true);
                            }
                            // else if (_searchWay === "Equal") {
                            //     _searchWaySql += " [ColName] =" + await CmnMis.Func.ProcSqlStr(_searchContentList[_i]);
                            // }
                            // else if (_searchWay === "NotEqual") {
                            //     _searchWaySql += " [ColName] <>" + await CmnMis.Func.ProcSqlStr(_searchContentList[_i]);
                            // }
                            else if (_searchWay === "NotInclude") {
                                _searchWaySql += " [ColName] not like  " + await CmnMis.Func.ProcSqlStr("%" + _searchContentList[_i] + "%",true);
                            }
                            else {
                                _searchWaySql += " [ColName] like  " + await CmnMis.Func.ProcSqlStr("%" + _searchContentList[_i] + "%",true);
                            }
                        }
                    }

                    if (_colName.indexOf("/") >= 0) { //是多字段
                        _colName = _colName.split("/");

                        var _where = "";

                        for (_i = 0; _i < _colName.length; _i++) {
                            if (_where !== "") { _where += " or "; }

                            _where += _searchWaySql.replace(/\[ColName\]/g, "[" + _colName[_i] + "] ");
                        }

                        this.CurUserForm.AddCondition(_where, "cmn_SearchCondition");
                    }
                    else { //一个字段
                        this.CurUserForm.AddCondition(_searchWaySql.replace(/\[ColName\]/g, "[" + _colName + "] "), "cmn_SearchCondition");
                    }
                }
                //搜索内容为空且存在单个搜索字段
                else if (_colName.indexOf("/") === -1) {
                    if (_searchWay === "Equal") {
                        this.CurUserForm.AddCondition("[" + _colName + "] is null or [" + _colName + "]=''", "cmn_SearchCondition");
                    }
                    else if (_searchWay === "NotEqual") {
                        this.CurUserForm.AddCondition("[" + _colName + "] is not null and [" + _colName + "]<>''", "cmn_SearchCondition");
                    }
                }
            }
        },
        OnSearch: async function(searchParam) {

            if (this.CurUserForm.BeforeSearch.Trigger([searchParam]) === false) { return; }

            //不在结果集中查找
            if (!searchParam.FindInResults) {
                this.CurUserForm.ClearCondition("cmn_SearchCondition");
            }

            //多条件
            if(searchParam.MultipleConditions) {

                for(let _i=0; _i<searchParam.ConditionList.length; _i++) {
                    await this.AddCondition(searchParam.ConditionList[_i]);
                }
            }
            else {
                await this.AddCondition(searchParam);
            }

            this.CurUserForm.ShowRecListPanel().then(()=>{}, () => {
                Cmn.Modal.Error("筛选条件错误！请重新输入。");
            });
        },
        //点击返回前一个表单按钮
        OnReturnPreUserFormClick: function() {
            // if (this.CurUserForm.ViewStateData && this.CurUserForm.ViewStateData.ReturnUserFormKey) {
            //     CmnMis.Frame.ShowUserFormByKey(this.CurUserForm.ViewStateData.ReturnUserFormKey, null, this.CurUserForm.ViewStateData.IsReloadWhenReturn);
            // } else if(CmnMis.PreUserForm && (!this.CurUserForm.ViewStateData || this.CurUserForm.ViewStateData.IsShowPreUserForm !== "0" || this.CurUserForm.ViewStateData.IsShowPreUserForm !== 0)) {
            //     CmnMis.Frame.ShowUserForm(CmnMis.PreUserForm.UserFormID, CmnMis.PreUserForm.GetViewStateData(), this.CurUserForm.ViewStateData?.IsReloadWhenReturn);
            // } else if (this.CurUserForm.ViewStateData && this.CurUserForm.ViewStateData.ReturnUserFormID) {
            //     CmnMis.Frame.ShowUserForm(this.CurUserForm.ViewStateData.ReturnUserFormID, null, this.CurUserForm.ViewStateData.IsReloadWhenReturn);
            // }
            CmnMis.Frame.ReturnUserForm();
        },
        //点击返回前一个表单按钮，做兼容
        OnReturnClick: function() {
            CmnMis.Frame.ReturnUserForm();
        },
        //显示用户表单字段信息
        OnSetColClick: function() {
            CmnMis.Frame.ShowSetUserFormCol(this.CurUserForm.UserFormID, this.CurUserForm.UserFormID);
        },
        //显示用户表单高级配置
        OnAdvancedCfgClick: function() {
            CmnMis.Frame.ShowUserFormAdvancedCfg(this.CurUserForm.UserFormID);
        },
        //调试表单SelectSql
        OnDebugSelectSqlClick: function() {
            window.open(`${SiteConfig.GetUrl(`/Tools/UserFormSqlTest.htm`, SiteConfig.OldProjectBaseUrl)}?SysName=${Cgl.Url.GetParamFromUrl("SysName") 
                || "javaframework"}&userformid=${this.CurUserForm.UserFormID}`)
        },
        //导入Csv
        OnImportCsvClick: function() {

        },
        //保存筛选条件
        OnSaveFilterConditionClick: function() {

        },
        //导出Excel
        OnDownloadExcelClick: async function () {

            //触发下载Excel事件
            if (this.CurUserForm.OnDownloadExcel.Trigger() === false) {
                return;
            }

            let _downUrl = new URL(await this.CurUserForm.GetDownloadUrl(), window.location.origin);
            _downUrl.searchParams.append("cmn_sys_guid", SiteConfig.SysGUID || "");
            _downUrl = _downUrl.href;
            
            var _postData = {};

            if (this.CurUserForm.ExdCfg !== "" && this.CurUserForm.ExdCfg["OutputDataSql"] !== undefined && this.CurUserForm.ExdCfg["OutputDataSql"] !== "") {
                //加密后最后多了一个换行符，必须要去掉，否则接口验证通不过
                _postData["cmn_OutputDataSql"] = CmnMis.Func.EncryptEncStr(this.CurUserForm.ExdCfg["OutputDataSql"]).replace(/\n/g,"");
            }

            var _form = document.createElement("form");
            _form.addEventListener("submit", (e) => {
                e.preventDefault();
            }, {once: true});

            _form.setAttribute("action", _downUrl);
            _form.setAttribute("method", "post");

            for (var _key in _postData) {

                var _input = document.createElement("input");
                _input.setAttribute("type", "hidden");
                _input.setAttribute("name", _key);
                _input.setAttribute("value", _postData[_key]);

                _form.appendChild(_input);
            }
            
            document.body.appendChild(_form);
            _form.submit();
            _form.remove();
        }
    }
}
